export default __webpack_public_path__ + "static/media/checked.a59edfd6.svg";